import { FEATURE_TAGS_SEPARATOR, FEATURE_TAGS_STORAGE_KEY } from './constants';

export const readFeatureTags = (): string[] => {
  const featureTagsString = localStorage.getItem(FEATURE_TAGS_STORAGE_KEY);
  const featureTags = featureTagsString ? featureTagsString.split(FEATURE_TAGS_SEPARATOR).map(tag => tag.trim()) : [];
  return featureTags;
};
export const getFeatureValue = (featureFlag: string): boolean => {
  return readFeatureTags().includes(featureFlag);
};
export const isMoPage = (): boolean => {
  const page = localStorage.getItem('newron_last_visited');
  return page ? page.includes('/mo') : false;
};
